import { Card, HeaderMenu } from "components";
import { TabDepreciation, TabGeneralAsset, TabHistori, TabMainteance, TabPicture, TabProfile, TabSection, TabUsage } from "./components";
import { useContext, } from "react";
import { FormDataContext, FormDataProvider } from "./context";

export default function ProfileAsset() {
    
    return (
        <FormDataProvider>
            <div className="container my-2">
                <HeaderMenu title="DATA ENTRY | PROFILE ASSET" />

                <Card>
                    <Card.Body>
                        <TabSection />
                        <TabForm/>
                    </Card.Body>
                </Card>
            </div>
        </FormDataProvider>
    )
}

function TabForm() {
    const { activeTab } = useContext(FormDataContext)
    return (
        <div className="lg:flex gap-2">
            <div className="lg:w-[34%] w-full border border-[#dadada] dark:border-[#3c3c3c] overflow-x-scroll max-h-[calc(100vh-390px)]">
                <div className="w-full">
                    <div className="w-full p-6">
                        <TabGeneralAsset />
                    </div>
                </div>
            </div>
            <div className="lg:w-[66%] w-full border border-[#dadada] dark:border-[#3c3c3c] overflow-x-scroll max-h-[calc(100vh-390px)]">
                {activeTab.value === "profile" && <TabProfile />}
                {activeTab.value === "depreciation" && <TabDepreciation />}
                {activeTab.value === "maintenance" && <TabMainteance />}
                {activeTab.value === "picture" && <TabPicture />}
                {activeTab.value === "usage" && <TabUsage />}
                {activeTab.value === "histori" && <TabHistori />}
            </div>
        </div>
    )
}